import classNames from "classnames";
import "./index.scss";
import { CustomIcon } from "..";

type Props = {
  item: any;
  editable?: boolean;
  removable?: boolean;
  onEdit?: (event: any) => void;
  onRemove?: (event: any) => void;
  onClick?: (event: any) => void;
  fieldName?: string;
  image?: string;
};

const CustomCard = ({
  item,
  editable,
  removable,
  onEdit,
  onRemove,
  fieldName,
  onClick,
  image,
}: Props) => {
  return (
    <div className="category-card" onClick={onClick}>
      {image && (
        <div className="card-image">
          <img src={image} />
        </div>
      )}
      <div>{item?.[fieldName as string]}</div>

      <div className="icons-wrapper">
        {editable && (
          <CustomIcon
            onClick={() => onEdit!(item)}
            icon="fa fa-pen"
            hoverTitle={"ویرایش"}
          />
        )}
        {removable && (
          <CustomIcon
            onClick={() => onRemove!(item)}
            icon="fa fa-remove"
            hoverTitle={"حذف"}
          />
        )}
      </div>
    </div>
  );
};

export default CustomCard;
